// Injects the app's RUM reporter and HTML apply shell into the @heidi/editor seams.
import { applyHtmlContentPreservingSelection } from '@/components/tiptap/utils/applyContentPreservingSelection';
import { reportDestroyedEditorAccess } from '@/utils/telemetry/editor-observability';
import { configureEditor } from '@heidi/editor/core';

configureEditor({ applyHtmlContentPreservingSelection, reportDestroyedEditorAccess });
